import { render, staticRenderFns } from "./UcInvoiceNumberingSelector.yaml?vue&type=template&id=180171ba&component"
import script from "./UcInvoiceNumberingSelector.yaml?vue&type=script&lang=ts&component"
export * from "./UcInvoiceNumberingSelector.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports